<script lang="ts">
  import { app_user } from '../../Users/observables'
  import TopBarPage from './TopBarPage.svelte'
  import NoAccountCta from '../NoAccountCTA.svelte'
  import VerifyEmailCta from '../VerifyEmailCta.svelte'
  import LapsedSubscriptionCta from '../LapsedSubscriptionCTA.svelte'
</script>

<TopBarPage>
  {#if $app_user.state === 'Loading'}
    <p>Loading...</p>
  {:else if $app_user.state === 'NoAccount'}
    <NoAccountCta />
  {:else if $app_user.state === 'UnverifiedEmail'}
    <VerifyEmailCta />
  {:else if $app_user.state === 'LapsedSubscription'}
    <LapsedSubscriptionCta />
  {:else}
    <slot />
  {/if}
</TopBarPage>
